import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function TASeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-816">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-817">
        <div data-id="element-818">
          <h2 className="text-3xl font-bold mb-1" data-id="element-819">Bodor TA Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-820">
            Automatic Loading &amp; Unloading Fiber Laser Tube Cutting Machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-821">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-822">
          <div className="md:col-span-5 flex flex-col items-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-823">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/Laser%20Tube%20Cutter/Bodor%20TA%20Series%20Laser%20Tube%20Cutting%20Machine.PNG" alt="Bodor TA Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl mb-4" data-id="element-824" />
            <span className="bg-[#f5693d] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider text-center" data-id="element-825">
              Bigger than Bigger
            </span>
          </div>
          <div className="md:col-span-7" data-id="element-826">
            <p className="text-gray-700 text-lg mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-827">
              The maximum cutting diameter of T series is 30% longer than the
              mainstream products in the market; The maximum cutting weight is
              100% heavier than the mainstream products in the market.
            </p>
            <ul className="space-y-4 text-gray-700" data-id="element-828">
              <li data-id="element-829">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-830">
                  Chuck position control, torque control function
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-831">
                  The position control CNC self-centering chuck with independent
                  intellectual property rights can automatically clamp material
                  according to the input tube size; Position monitoring in
                  torque mode to ensure that the thick tube is not loosened and
                  the small tube is not deformed; Brand new dust-proof
                  structure, long-lasting use without lagging.
                </span>
              </li>
              <li data-id="element-832">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-833">
                  Edge-seeking, center-finding
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-834">
                  Brand new function of edge-seeking, center-finding. Optimized
                  edge-finding method and algorithm, higher cutting precision
                  and stability.
                </span>
              </li>
              <li data-id="element-835">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-836">
                  Touch Control
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-837">
                  The first one to use UI design in the world which lets display
                  respond to processing table, making processing more intuitive.
                  1920*1080 high-definition capacitive 10 points touch screen.
                  Elegant curves precisely fit machine body. Strong waterproof
                  breathable system creates the best space, making operation
                  more convenient. Diamond cutting process and HD plasma
                  tempered glass make screen more exquisite and comfortable to
                  use.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-838">
              <a href="https://www.peakedm.com/m7/Bodor%20TA%20Series--ta-series-fiber-laser-tube-cutting-with-automatic-loading-unloading.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-839">
                <span className="mr-2" data-id="element-840">+</span> Discover More
              </a>
              <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Brochure%20Bodor%20T%20series%20Fiber%20Laser%20Tube%20Cutter.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-841">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-842" /> Download Brochure
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-843">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-844">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-845">
              <tr data-id="element-846">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/3" data-id="element-847">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200 w-1/3" data-id="element-848">
                  T230A
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center w-1/3" data-id="element-849">
                  T360A
                </th>
              </tr>
            </thead>
            <tbody data-id="element-850">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-851">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-852">
                  Effective Tube Cutting Length
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-853">
                  6500mm/9200mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-854">6500mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-855">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-856">
                  Laser Power
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-857">
                  6000w/3000w/2000w/1500w
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-858">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-859">
                  Round Tube Cutting Diameter
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-860">
                  Φ20-230mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-861">Φ20-360mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-862">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-863">
                  Square Tube Cutting
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-864">
                  □20*20mm-□160*160mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-865">□20*20mm-□254*254mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-866">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-867">
                  Rectangular Tube Edge Length
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-868">
                  20-170mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-869">20-300mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-870">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-871">
                  Rectangular Tube Outer Circle Dia
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-872">
                  ≤230mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-873">≤360mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-874">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-875">
                  Positioning accuracy
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-876">
                  0.05mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-877">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-878">
                  Repositioning accuracy
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-879">
                  0.03mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-880">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-881">
                  X axis max speed
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-882">
                  100m/min
                </td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-883">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-884">
                  Y axis max speed
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-885">
                  95m/min
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}